<template>
  <div class="d-flex min-vh-100">
    <CContainer fluid>
        <CCard
            accentColor='#122efe'
            align='center'
        >
            <CCardHeader class='d-flex justify-content-between'>
                <div class="d-flex align-items-baseline">
                    <CIcon name="cil-loop" size="xl" class='mr-2' />
                    <h3 class='m-0 font-weight-bold'>
                        Ordenes automáticas
                    </h3>
                </div>
               
            </CCardHeader>
            <CCardBody>
                <CRow>
                    <CCol sm='5'>
                        <CInput placeholder='Buscar...' v-model='filter' >
                            <template #append-content>
                                <CIcon size='sm' name='cil-magnifying-glass'/>
                            </template>
                        </CInput>
                    </CCol>
                    <!--<CCol sm='2'>
                        <CSelect 
                            ref='filter-status'
                            :options='statuses'
                            :key='filterKeys.status.key + filterKeys.status.value'
                            placeholder='Filtrar por Estado...' 
                            @change="applyFilter('status', $event)"
                            />
                    </CCol>-->
                    <CCol sm='3'>
                        <CSelect 
                            ref='filter-priority'
                            :options='priorities' 
                            :key='filterKeys.priority.key + filterKeys.priority.value'
                            placeholder='Filtrar por Prioridad...' 
                            @change="applyFilter('priority', $event)"
                        />
                    </CCol>
                    <CCol sm='3'>
                        <CSelect 
                            ref='filter-department'
                            :options='departments'
                            :key='filterKeys.department.key + filterKeys.department.value'
                            placeholder='Filtrar por Sector...' 
                            @change="applyFilter('department', $event)"
                        />
                    </CCol>
                    <CCol sm='1'>

                        <CButton 
                            v-c-tooltip='"Quitar filtros"'
                            color='danger'
                            size='sm'
                            @click='clearFilters'>
                            <CIcon name='cil-trash' />
                        </CButton>
                    </CCol>
                </CRow>
                <CRow class='justify-content-center'>
                    <div class="responsive-datatables">
                        <datatable
                            class='table datatable'
                            :columns='tableFields'
                            :data='filteredRows'
                            :filter='filter'
                            :per-page='10'
                        >
                            <template slot-scope="{ row }">
                                <tr>
                                    <td>{{row.id}}</td>
                                    <td>{{row.description ? row.description.text : '-'}}</td>
                                    <!--<td>{{row.status.name}}</td>-->
                                    <td>{{row.priority.name}}</td>
                                    <td>{{row.department.name}}</td>
                                    <td>
                                        <CButton
                                            v-c-tooltip='"Ver Orden"'
                                            color='info'
                                            size='sm'
                                            @click="getOrder(row.id)"
                                            class='mr-xl-1'
                                        >
                                            <CIcon name='cil-magnifying-glass' size='sm' />
                                        </CButton>
                                        <CButton
                                            v-c-tooltip='"Modificar Orden"'
                                            color='warning'
                                            size='sm'
                                            @click="updateOrder(row.id)"
                                            v-if='userIsAdmin || userIsApprover'
                                        >
                                            <CIcon name='cil-pencil' size='sm'/>
                                        </CButton>
                                        <template v-if="row.deleted_at == null">
                                            <CButton
                                                v-c-tooltip='"Eliminar Orden"'
                                                class='ml-xl-1'
                                                color='danger'
                                                size='sm'
                                                @click='deactivateOrder(row.id)'>
                                                <CIcon name="cil-trash" size="sm" />
                                            </CButton>
                                        </template>
                                        <!--
                                        <template v-else>
                                            <CButton
                                                v-c-tooltip='"Activar Orden"'
                                                class='ml-xl-1'
                                                color='dark'
                                                size='sm'
                                                @click="toggleOrderActivation(row.id, true)">
                                                <CIcon name="cil-chevron-top" size="sm"/>
                                            </CButton>
                                        </template>
                                        -->
                                    </td>
                                </tr>
                            </template>
                        </datatable>
                        <datatable-pager v-model='page' class='paginator'></datatable-pager>
                    </div>
                </CRow>
            </CCardBody>
        </CCard>
         
    </CContainer>
    <CContainer fluid class='order-modal-backdrop' v-if='showOrder' >
        <CRow class='order-modal-row'>
            <CCol class='order-modal-container'>
                <ScheduledOrderModal class='order-modal' :order='orderShowed'   />
            </CCol>
        </CRow>
    </CContainer>
  </div>
</template>

<script>
import axios from 'axios';
import ScheduledOrderModal from '../../components/ScheduledOrderModal';
export default {
    components: {
        ScheduledOrderModal
    },
    data(){
        return {
            row: 10,
            page: 1,
            showOrder: false,
            orderShowed: {},
            tableFields: [
                {label: 'ID', field: 'id', filterable: false},
                {label: 'Descripción', field: 'description', representedAs: (row) => row.description.text},
                //{label: "Estado", field: 'status', representedAs: (row) => row.status.id},
                {label: "Prioridad", field: 'priority', representedAs: (row) => row.priority.id},
                {label: "Sector", field: 'department', representedAs: (row) => row.department.id},
                {label: "Acciones", field: 'actions', filterable: false, orderable: false}
            ],
            filter: '',
            filters: [],
            // Datos para los selects
            departments: [],
            priorities: [],
            statuses: [],
            // Estado de los selects (para limpiar el filtro)
            ordersData: [],
            filterKeys: {
                department: {
                    key: 'department-filter-',
                    value: 1
                },
                priority: {
                    key: 'priority-filter-',
                    value: 1
                }
            }

        }
    },
    created(){
        this.getExternalData();
        this.getOrdersData();
        console.log(this.$router.options.routes)
    },
    mounted(){
        this.getExternalData();
        this.getOrdersData();
        let me = this;
        this.$root.$on('close-modal', () => {
            me.closeOrderModal();
        })

    },
    methods: {
        getExternalData(){
            let me = this;
            let request_1 = me.$api.departments.index();
            let request_2 = me.$api.priorities.index();
            let request_3 = me.$api.statuses.index();
            axios.all([request_1, request_2, request_3])
            .then(axios.spread((response_1, response_2, response_3) => {
                me.departments = [];
                me.departments = response_1.data.data.map(item => {
                    return {
                        value: item.id,
                        label: item.name
                    }
                });

                me.priorities = [];
                me.priorities = response_2.data.data.map(item => {
                    return {
                        value: item.id,
                        label: item.name
                    }
                });

                me.statuses = [];
                me.statuses = response_3.data.data.map(item => {
                    return {
                        value: item.id,
                        label: item.name
                    }
                })
            }))
            .catch(error => {
                console.log(error);
                console.log(error.response);
            });
        },
        getOrdersData(){
            let me = this;
            return this.$api.scheduled_orders.index().then(res => me.ordersData = res.data.data);
        },
        updateOrder(id){
            this.$router.push({ path: `ordenes_automaticas/modificar/${id}`});
        },
        getOrder(id){
            this.$api.scheduled_orders.show(id)
            .then(res => {
                this.orderShowed = res.data.data[0];
                this.showOrder = true;
            })
            .catch(error => {
                console.log(error)
                console.log(error.response)
            })
            // Ver que onda como ve el user una orden. idealmente sería un modal.
        },
        closeOrderModal(){
            this.showOrder = false;
        },
        toggleOrderActivation(id, shouldActivate){
            if(shouldActivate){
                this.activateOrder(id);
            } else {
                this.deactivateOrder(id);
            }
        },
        activateOrder(id){
            this.$swal.fire({
                title: "¿Activar orden?",
                text: "¿Está seguro que desea activar la creación de esta orden?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: "Si",
                cancelButtonText: "No"
            }).then(result => {
                if (result.isConfirmed) {
                    this.$api.scheduled_orders.activate(id)
                    .then(res => {
                        this.$swal.fire({
                             titleText: "¡Excelente!",
                             text: res.message ?? "Orden activada exitosamente",
                             icon: "success"
                         }).then(result => {
                             this.getOrdersData();
                         });
                    })
                    .catch(error => {
                        console.log(error);
                          if(error){
                              this.$swal.fire({
                                titleText: "Algo salió mal",
                                text: error.response ? error.response.message : "Error al crear",
                                icon: "error"
                            });
                          }
                    })
                }
            })
        },
        deactivateOrder(id){
            this.$swal.fire({
                title: "¿Eliminar orden?",
                text: "¿Está seguro que desea eliminar esta orden?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: "Si",
                cancelButtonText: "No"
            }).then(result => {
                if (result.isConfirmed) {
                    this.$api.scheduled_orders.deactivate(id)
                    .then(res => {
                        this.$swal.fire({
                             titleText: "¡Excelente!",
                             text: res.message ?? "Orden eliminada exitosamente",
                             icon: "success"
                         }).then(result => {
                             this.getOrdersData();
                         });
                    })
                    .catch(error => {
                        console.log(error);
                          if(error){
                              this.$swal.fire({
                                titleText: "Algo salió mal",
                                text: error.response ? error.response.message : "Error al actualizar",
                                icon: "error"
                            });
                          }
                    })
                }
            })
        },
        applyFilter(column_name, event){
            console.log(event);
           let filterAppliedIndex = this.filters.findIndex(filter => filter.column === column_name);
            
            // Si ya hay aplicado un filtro, solo actualizamos el valor
           if (filterAppliedIndex >= 0 ){
               this.filters[filterAppliedIndex].value = event.target.value;
           } else {
               this.filters.push({
                   column: column_name,
                   value: event.target.value
               })
           }
        },
        clearFilters(){
           
            this.filterKeys.department.key += 1;
            this.filterKeys.priority.key += 1;   
            this.filters = [];
        },
        shouldReturn(row){
            let checks = []; // false x default

            this.filters.forEach(filter => {    // Por cada una de las entradas en filters
                let value = filter.value;
                let column = filter.column;
               
                if(parseInt(row[column].id) === parseInt(value)){
                    checks.push(true);
                } else {
                   checks.push(false);
                }
                
            })
            let shouldReturn = checks.indexOf(false) === -1 ? true : false;
            return shouldReturn;
        },
    },
    computed: {
        // Roles harcodeados, ver que onda.
        userIsAdmin(){
            return this.$store.state.user.role_id === 1;
        },
        userIsPetitioner(){
            return this.$store.state.user.role_id === 2;
        },
        userIsApprover(){
            return this.$store.state.user.role_id === 3;
        },
        filteredRows(){
            if (this.filters.length === 0 ){
                return this.ordersData;
            } else {
                return this.ordersData.filter(this.shouldReturn);
            }
        }
    },
    watch: {
        filters: function (newVal, oldVal) {
            this.filteredRows;
        }
    }
}
</script>

<style lang='scss'>
.responsive-datatables{
      padding: 2rem;
      width: 100%;
      height: 100%;

    }
.order-modal-backdrop{
     position: fixed;
     z-index: 5000;
    top: 50%;
    left: 50%;
    width: 100vw;
    height: 100vh;
    transform: translate(-50%, -50%);
    background-color: rgba(0, 0, 0, 0.5);
}
.order-modal-row{
    height: 100vh;
}
.order-modal-container{
    display: flex;
}
.order-modal{
    margin: auto;
    width: max-content;
    position: relative;
    z-index: 5001;
}

</style>
